var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"[@desjardins: URL_OF_C1_GUIDELINES]","target":"_blank","aria-describedby":"new-window-warning","rel":"noopener noreferrer"}},[_vm._v(" [@desjardins: NAME_OF_C1_GUIDELINES] ")])
}
var staticRenderFns = []

export { render, staticRenderFns }